import { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import { useKeepCommunityContentMutation } from 'generated/graphql';

type KeepContentArgs = {
  reportIds: number[];
};

export const useKeepContent = () => {
  const [keepContentMutation] = useKeepCommunityContentMutation();

  return useCallback(
    ({ reportIds }: KeepContentArgs) =>
      Promise.all(
        reportIds.map((contentId) =>
          keepContentMutation({ variables: { contentId } }),
        ),
      )
        .then(() => {
          toast.success('Post kept');
        })
        .catch(() => {
          toast.error('Something went wrong');
        }),
    [keepContentMutation],
  );
};
